import React, { Component } from 'react'
import styled from '@emotion/styled'
import { Box, RoundedLabel, Icons, PalletParcelInfoModal, ItemStatusLabel, PalletStatus } from 'components'
import { CustomTmrItem } from 'api/types'
import { T, __ } from 'translations/i18n'
import { Spacer } from './Various'

interface Props {
  id: any
  item: CustomTmrItem
  onInfoPress?: (item: CustomTmrItem) => void
  onDeleteCallback?: (item: CustomTmrItem) => void
  itemState?: 'ERROR' | 'WARNING' | 'IGNORE'
}

interface State {
  visibleItemModal: boolean
}

export default class CustomItemRow extends Component<Props, State> {
  state: State = {
    visibleItemModal: false,
  }

  openItemInfoModal = () => this.setState({ visibleItemModal: true })
  closeItemInfoModal = () => this.setState({ visibleItemModal: false })

  onRowPress = () => {
    const { onInfoPress, item } = this.props
    if (onInfoPress) return () => onInfoPress(item)
    if (!onInfoPress) return this.openItemInfoModal
    return undefined
  }

  getItemMessages = () => {
    const { item, itemState } = this.props
    const messages: { message: string; status: 'error' | 'warning' }[] = []
    item.__processedStates
      ?.filter((state) => (itemState ? state.processedState === itemState : true))
      .forEach((processedState) => {
        if (processedState.itemState === 'ITEM_NOT_IN_INBOUND')
          messages.push({
            message: __(T.error.item_not_in_inbound),
            status: processedState.processedState.toLowerCase() as 'error' | 'warning',
          })
        if (processedState.itemState === 'ITEM_NOT_IN_STOCK')
          messages.push({
            message: __(T.error.item_not_in_stock),
            status: processedState.processedState.toLowerCase() as 'error' | 'warning',
          })
        if (processedState.itemState === 'ITEM_IN_ANOTHER_PARCEL')
          messages.push({
            message: __(T.error.item_in_another_parcel),
            status: processedState.processedState.toLowerCase() as 'error' | 'warning',
          })
        if (processedState.itemState === 'ITEM_IN_ANOTHER_PRODUCTION_ORDER')
          messages.push({
            message: __(T.error.item_in_another_production_order),
            status: processedState.processedState.toLowerCase() as 'error' | 'warning',
          })
      })

    if (messages.length === 0) return undefined

    return messages
  }

  onDeletePress = () => {
    const { onDeleteCallback, item } = this.props
    if (onDeleteCallback) return () => onDeleteCallback(item)
    return undefined
  }

  render() {
    const { item, id, onDeleteCallback } = this.props
    const { visibleItemModal } = this.state
    if (!item) return <></>

    const messages = this.getItemMessages()

    return (
      <Row row id={id} onClick={onDeleteCallback ? undefined : this.onRowPress()}>
        <Box center p={10}>
          <Icons.Rfid style={{ width: 100, height: 100, padding: 10 }} />
        </Box>
        <Separator />
        <Box flex p={20} pr={0}>
          <Box style={{ maxWidth: 'fit-content', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
            <ProductCode>{item.orderNumber ?? __(T.misc.unknown).toUpperCase()}</ProductCode>
          </Box>
          <Spacer />
          <Box row style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <RoundedLabel mb={4} maxWidth={130} label={__(T.misc.country)} value={item?.country ?? '--'} />
            <RoundedLabel mb={4} maxWidth={300} label={__(T.misc.carrier)} value={item?.carrierCode ?? '--'} />
            <RoundedLabel mb={4} maxWidth={300} label={__(T.fields.carrier_desc)} value={item?.carrierDesc ?? '--'} />
            <RoundedLabel mb={4} maxWidth={300} label={'TRK'} value={item?.trackingCode ?? '--'} />
          </Box>
          {!!messages && (
            <Box row style={{ justifyContent: 'flex-start', marginTop: 10 }} flex>
              {messages &&
                messages.map((message) => <ItemStatusLabel status={message.status} value={message.message} />)}
            </Box>
          )}
        </Box>
        {!!item.parcelStatus && (
          <Box p={15} center>
            <PalletStatus status={item.parcelStatus} />
          </Box>
        )}
        {onDeleteCallback && (
          <Box p={30} center onClick={this.onDeletePress()}>
            <Icons.Delete />
          </Box>
        )}
        {this.onRowPress() && !onDeleteCallback && (
          <Box p={30} center>
            <Icons.Info />
          </Box>
        )}
        {visibleItemModal && (
          <PalletParcelInfoModal visible={visibleItemModal} item={item} onClose={this.closeItemInfoModal} />
        )}
      </Row>
    )
  }
}

const Row = styled(Box)`
  margin-bottom: 20px;
  border: 2px solid #edecec;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
`

const Separator = styled.div`
  width: 2px;
  height: 100%;
  background-color: #edecec;
`

const ProductCode = styled.div`
  font-weight: 900;
  font-size: 28px;
`
